var _ellipse, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvenuChatbot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.9952,
    cy: 22.1087,
    rx: 21.3284,
    ry: 21.3285,
    fill: "#316AF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8926 34.2193L31.1801 12.9835C31.4063 12.0748 30.6101 11.2465 29.7365 11.4819L23.6814 13.1131C22.878 13.3292 22.603 14.372 23.1902 14.9827C23.8719 15.6903 24.5249 16.5871 24.9732 17.5659C25.3384 18.3629 26.2635 20.3814 25.4372 21.6432C24.5693 22.9661 22.6202 22.1333 21.5847 23.0748C20.5235 24.0417 20.3001 26.7946 23.6929 34.4592C23.7458 34.5784 23.8189 34.6886 23.9091 34.781C24.5564 35.4543 25.6635 35.1415 25.8926 34.2193Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30052 16.9894C8.44696 17.2352 8.44266 18.497 9.29048 18.7652C11.8998 19.589 17.0928 21.0995 20.381 21.1189C21.3133 21.1249 23.4672 21.1368 24.0057 19.9793C24.0329 19.9212 24.1145 19.7335 24.1317 19.4087C24.2191 17.7551 22.4146 16.2044 21.2288 15.0707C20.57 14.4405 19.6491 14.2007 18.7827 14.4346L9.32198 16.9835C9.32198 16.9835 9.30909 16.9865 9.30193 16.9894H9.30052Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvenuChatbot);
export default __webpack_public_path__ + "static/media/AvenuChatbot.cfebd7e79da5b7557e3eec561b70bdad.svg";
export { ForwardRef as ReactComponent };